import Cache from "./Cache"
import IMapStorage from "./IMapStorage"
import MemoryMapStorage from "./MemoryMapStorage"
import Storage from "./Storage"

export {Cache, IMapStorage, MemoryMapStorage, Storage};
export default {Cache, IMapStorage, MemoryMapStorage, Storage}
